import React from 'react';

const Badge = (props) => {
  return <Badge {...props}></Badge>;
};

export default Badge;
